import { render, staticRenderFns } from "./DashboardWidgetAndamentoVendite.vue?vue&type=template&id=a9d61ac2&"
import script from "./DashboardWidgetAndamentoVendite.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetAndamentoVendite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports